'use client'
import {QRCodeCanvas} from 'qrcode.react';

const QRCodeGenerator = ({ url, dictionary }) => {
    return (
        <div className='flex flex-col items-center border-secondary border-[1px] rounded-md p-4 my-4'>
            <QRCodeCanvas
                value={url}
                size={256}
                bgColor={"#ffffff"}
                fgColor={"#000000"}
                level={"L"}
                includeMargin={false}
                imageSettings={{
                    src: "",
                    x: undefined,
                    y: undefined,
                    height: 24,
                    width: 24,
                    excavate: true,
                }}
            />
            <span className='mt-4 text-secondary'>{dictionary.scanQr}</span>
        </div>
    )
}

export default QRCodeGenerator